import { useLocation, useNavigate } from 'react-router-dom';
import { Paths } from '../routes/paths';
import { useAppLoadedStore } from '../stores/appLoadedStore';
import { storeWebsiteUrl } from './urlUtils';
import { useToastMessage } from './uiUtils';
import { GeneralConfig } from '../config/generalConfig';
import { useTranslation } from 'react-i18next';

export const useNavigateAfterLogin = () => {
  const navigate = useNavigate();

  const navigateAfterLogin = (
    isDemoAllowed: boolean,
    isUserActive: boolean
  ) => {
    if (isDemoAllowed) {
      if (isUserActive) {
        navigate(Paths.HomeDashboard);
      } else {
        navigate(Paths.AccountBlocked);
      }
    } else {
      navigate(Paths.DemoBlocked);
    }
  };

  return { navigateAfterLogin };
};

export const useNavigateAfterLogout = () => {
  const navigate = useNavigate();

  const navigateAfterLogout = () => {
    navigate(Paths.Login);
  };

  return { navigateAfterLogout };
};

export const isPageRefreshed = (): boolean => {
  const { status } = useAppLoadedStore.getState();
  return !status;
};

export const navigateToStoreWebsite = function (route?: string) {
  window.open(storeWebsiteUrl(route), '_blank');
};

export const navigateToStoreSsoLogin = function (token: string) {
  window.open(
    storeWebsiteUrl(`route=account/sso_login&token=${token}`),
    '_blank'
  );
};

export const navigateToStoreSsoLogout = function (token: string) {
  window.open(
    storeWebsiteUrl(`route=account/sso_logout&token=${token}`),
    '_blank'
  );
};

export const navigateToStorePurchase = function (category: number) {
  window.open(
    storeWebsiteUrl(`route=product/category&path=${category}`),
    '_blank'
  );
};

export const useKeepAlive = (): boolean => {
  return false;
  const location = useLocation();
  return location.state?.keepAlive === true;
};

export const useDemoAction = () => {
  const { showErrorMessage } = useToastMessage();
  const { t } = useTranslation();

  const checkDemoAction = () => {
    if (GeneralConfig.isDemo) {
      showErrorMessage(t('common:featureUnavailableInDemo'));
      return true;
    }
    return false;
  };

  return { checkDemoAction };
};
